
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75 6.188H5.5c0 .758.617 1.375 1.375 1.375H8.25c.758 0 1.375-.617 1.375-1.375h9.625a.687.687 0 100-1.375H9.625c0-.759-.617-1.375-1.375-1.375H6.875c-.758 0-1.375.616-1.375 1.374H2.75a.687.687 0 100 1.375zM19.25 10.313h-4.125c0-.759-.617-1.376-1.375-1.376h-1.375c-.758 0-1.375.617-1.375 1.376H2.75a.687.687 0 100 1.374H11c0 .759.617 1.376 1.375 1.376h1.375c.758 0 1.375-.617 1.375-1.376h4.125a.687.687 0 100-1.374zM19.25 15.813H9.625c0-.759-.617-1.376-1.375-1.376H6.875c-.758 0-1.375.617-1.375 1.376H2.75a.687.687 0 100 1.374H5.5c0 .759.617 1.375 1.375 1.375H8.25c.758 0 1.375-.616 1.375-1.375h9.625a.687.687 0 100-1.375z"}})])
          )
        }
      }
    